// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */
import * as React from 'react';

import type { InteractionType } from './InteractionLogger';
import { InteractionLogger, TrackingNamespaceContext } from './interactions';

type loggingFunction = (
  event: SyntheticEvent<*>,
  interactionType: InteractionType,
  impressionId: string,
  pageviewId: string,
  sessionId: string,
) => mixed;

const FareCardInteractionLogger = ({ children }: {| children: loggingFunction => React.Node |}) => (
  <TrackingNamespaceContext.Provider value="flights">
    <InteractionLogger>
      {logInteraction => {
        const logFirstClick = (e, i, impressionId, pageviewId, sessionId) => {
          const trackingParams: Object = {
            fareCardImpressionId: impressionId,
            pageviewId,
            sessionId,
          };

          logInteraction(e, i, trackingParams);
        };

        return children(logFirstClick);
      }}
    </InteractionLogger>
  </TrackingNamespaceContext.Provider>
);

export default FareCardInteractionLogger;
